import { MWApi, MWApiV2 } from './mw-api';
import MwApiBase from './mw-api-base';

function getApi(mode: string, version: number = 1): MwApiBase {
  switch (version) {
    case 2:
      return new MWApiV2(mode);
    default:
      return new MWApi(mode);
  }
}

export function useApi(mode: string): MWApi {
  const api = getApi(mode);
  return api as MWApi;
}

export function useApiV2(mode: string): MWApiV2 {
  const api = getApi(mode, 2);
  return api as MWApiV2;
}
